
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/month5",
      function () {
        return require("private-next-pages/month5/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/month5"])
      });
    }
  